import PropTypes from "prop-types";
import "./StatusBadge.scss";

const StatusBadge = ({ type, text, className, darkText, round, size }) => (
    <span
        className={`
            status-badge
            ${size ? ` status-badge--${size}` : ""}
            ${type ? ` status-badge--${type}` : ""}
            ${className ? ` ${className}` : ""}
            ${darkText ? " status-badge--dark-text" : ""}
            ${round ? " status-badge--round" : ""}`}
    >
        <span className={`status-badge--child`}>{text}</span>
    </span>
);

StatusBadge.defaultProps = {
    type: "",
    text: "",
    className: "",
    darkText: false,
    round: false,
    size: "",
};

StatusBadge.propTypes = {
    type: PropTypes.string,
    text: PropTypes.any,
    className: PropTypes.string,
    darkText: PropTypes.bool,
    round: PropTypes.bool,
    size: PropTypes.string,
};

export default StatusBadge;
